import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MailIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 px-6 bg-navy-light relative overflow-hidden" data-id="element-62">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-gold/5 to-transparent" data-id="element-63"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-65">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-66">
            <div className="w-12 h-px bg-gold" data-id="element-67"></div>
            <span className="text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-68">
              Get Started
            </span>
            <div className="w-12 h-px bg-gold" data-id="element-69"></div>
          </div>

          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-semibold text-white mb-6" data-id="element-70">
            Ready to Expand into
            <br data-id="element-71" />
            Global Procurement Markets?
          </h2>

          <p className="text-slate-400 text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-72">
            Whether you are a manufacturer seeking access to institutional
            procurement opportunities worldwide or a procurement entity
            requiring supplier coordination across global markets, we are here
            to help.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12" data-id="element-73">
            <Link to="/supplier-registration" className="bg-gold hover:bg-gold-dark text-navy-dark px-8 py-4 rounded-md font-semibold text-base transition-colors flex items-center justify-center gap-2" data-id="element-74">
              Pre-Qualification Form
              <ArrowRightIcon size={18} data-id="element-75" />
            </Link>
            <Link to="/contact" className="border-2 border-slate-700 hover:border-gold text-white px-8 py-4 rounded-md font-semibold text-base transition-colors" data-id="element-76">
              Contact Our Team
            </Link>
          </div>

          <div className="flex justify-center text-slate-400" data-id="element-77">
            <a href="mailto:info@888sourcing.co.uk" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-78">
              <MailIcon size={18} data-id="element-79" />
              <span className="text-sm" data-id="element-80">info@888sourcing.co.uk</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}